import { combineReducers } from 'redux';
import { UserReducer } from './user/reducer_user';
import { LoaderReducer } from './loader/reducer_loader';
import { reducer as formReducer } from 'redux-form';

const rootReducer = combineReducers({
    user: UserReducer,
    form: formReducer,
    showLoader: LoaderReducer
});

export default rootReducer;